import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";
import "./cardCourse.css";
import SnakeBarComponent from "./snakeBar";

function CourseCard({ course, style }) {
  const navigate = useNavigate();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const { t, i18n } = useTranslation();

  // Check if current language is RTL (Arabic)
  const isRTL = i18n.language === 'ar';
  
  // ✅ Navigate to course details
  const handleCourseClick = () => {
    if (!course?._id) return;
    navigate(`/course/${course._id}`);
  };

  // ✅ Fallback image if missing
  const courseImage = course?.image
    ? `${API_URL}/uploads/${course.image}`
    : "/default-course.png";

  // Format price for Arabic (RTL support)
  const formatPrice = (price) => {
    if (!price) return t("Free", "مجاني");
    
    if (isRTL) {
      return `${price} ${t("LE", "ج.م")}`;
    }
    return `${price} ${t("LE", "LE")}`;
  };

  // Format lectures count with proper pluralization
  const formatLectures = (lecturesCount) => {
    if (!lecturesCount) return course?.level || t("Unknown", "غير معروف");
    
    if (isRTL) {
      return `${lecturesCount} ${lecturesCount > 1 ? t("Lectures", "محاضرة") : t("Lecture", "محاضرات")}`;
    }
    return `${lecturesCount} ${lecturesCount > 1 ? t("Lectures", "Lectures") : t("Lecture", "Lecture")}`;
  };

  return (
    <>
      <div 
        className="course-card-modern" 
        style={style}
        dir={isRTL ? "rtl" : "ltr"}
      >
        {/* ✅ Image Section */}
        <div className="course-image-modern">
          <img
            src={courseImage}
            className="img-fluid"
            alt={t("CourseImageAlt", "صورة الكورس")}
            onError={(e) => {
              e.target.src = '/default-course.png';
            }}
          />
          {/* Lock icon for paid courses */}
          {course?.price > 0 && (
            <div className="course-lock-icon" title={t("PaidCourse", "كورس مدفوع")}>
              🔒
            </div>
          )}
        </div>

        {/* ✅ Info Section */}
        <div className="course-info-modern">
          <div className="course-title-modern" style={{fontSize:"1.5rem"}}>
            {course?.title || t("Untitled", "بدون عنوان")}
          </div>
          
          <div className="course-price-modern">
            <strong className="course-price-text">
              {formatPrice(course?.price)}
            </strong>
          </div>
        </div>

        {/* ✅ Details Section */}
        <div className="course-details-modern">
          <div className="course-detail-item" title={t("LecturesCount", "عدد المحاضرات")}>
            <span className="course-detail-icon">📊</span>
            {formatLectures(course?.lectures?.length)}
          </div>

          <div className="course-detail-item" title={t("CourseDuration", "مدة الكورس")}>
            <span className="course-detail-icon">⏰</span> 
            {course?.duration || 0} {t("Hours", "ساعة")}
          </div>

          <div className="course-detail-item" title={t("CourseRating", "تقييم الكورس")}>
            <span className="course-detail-icon">⭐</span> 
            {course?.rate || "0.0"}
          </div>
        </div>

        {/* ✅ Button */}
        <button
          onClick={handleCourseClick}
          className="course-view-btn"
        >
          {t("View Course", "عرض الكورس")}
        </button>
      </div>

      {/* ✅ Snackbar */}
      {showSnackbar && (
        <SnakeBarComponent
          isGood={false}
          message={t("LoginFirst", "يجب تسجيل الدخول أولاً")}
          open={showSnackbar}
          handleClose={() => setShowSnackbar(false)}
        />
      )}
    </>
  );
}

export default CourseCard;